import React, {Component} from 'react'
import {Panel} from '@sabre/spark-react'
import FlightsTable from './FlightsTable/index'
import FlightsToolbar from './FlightsToolbar/index'
import ScreenTemplate from 'shared/components/ScreenTemplate'
import {getLocalFlightDate, setDefaultLocalFlightDate} from 'shared/utils/localFlightDate'

export default class Flights extends Component {

    pageTitle = 'Flights'
    errorTitle = 'Error loading flights.'

    constructor(props, context) {
        super(props, context)
        setDefaultLocalFlightDate()
        this.actions = {
            showBriefings: (flightId) => this.showBriefings(flightId),
            showFilters: () => this.showFilters(),
            onDateChange: (flightDate) => this.onDateChange(flightDate)
        }
        this.state = {
            filters: false
        }
    }

    showBriefings(flightId) {
        this.props.history.push(`briefing/${flightId}`)
    }

    showFilters() {
        this.setState({filters: !this.state.filters})
    }

    onDateChange(flightDate) {
        this.props.actions.getData({flightDate: flightDate})
    }

    componentDidMount() {
        if (this.props.data !== undefined) return
        this.props.actions.getData({flightDate: getLocalFlightDate()})
    }

    componentWillUnmount() {
        this.props.actions.resetError()
    }

    render() {

        let message = this.props.error
            ? {type: "warning", title: this.props.error.title, text: this.props.error.text}
            : undefined
        return (
            <ScreenTemplate
                login={this.props.username !== undefined ? this.props.username : 'unknown'}
                activeMenuItem={this.pageTitle}
                actions={{onSignOut: this.props.signOut}}
                message={message}>
                <div className="col-xs-12">
                    <Panel>
                        <Panel.Content>
                            <FlightsToolbar actions={this.actions} title={this.pageTitle} />
                            <FlightsTable
                                actions={this.actions}
                                data={this.props.data}
                                filters={this.state.filters}
                                loading={this.props.isLoading}/>
                        </Panel.Content>
                    </Panel>
                </div>
            </ScreenTemplate>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/flights/components/index.js